import GaugeChart from "react-gauge-chart";
import { Grid } from "@material-ui/core";
import { Text } from "sunrise-ui";
import "./Projects.scss";

import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
} from "chart.js";
import { useEffect, useState } from "react";

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title
);

const getSpentTime = (fromDateString: string, toDateString: string) => {
  const fromDate = new Date(fromDateString);
  const toDate = new Date(toDateString);
  const spentTime = (toDate.getTime() - fromDate.getTime()) / 1000;

  const day = 86400;
  const hour = 3600;
  const minute = 60;

  const daysout = Math.floor(spentTime / day);
  //const hoursout = Math.floor((spentTime - daysout * day) / hour);
  // const minutesout = Math.floor((spentTime - daysout * day - hoursout * hour) / minute);
  // const secondsout = spentTime - daysout * day - hoursout * hour - minutesout * minute;

  // return `${daysout} days & ${hoursout} hours`;
  return {
    daysSpent: daysout,
    hoursSpent: Math.floor(spentTime / hour),
    minutesSpent: Math.floor(spentTime / minute),
    //toString: () => `${daysout} days & ${hoursout} hours`,
    toString: () => `${daysout} days`, //due client feedback hours removed
  };
};

const UserTimeSpent = (props: any) => {
  const { fromDate, toDate } = props;
  const [spentPercent, setSpentPercent] = useState(0);
  //const [remainingPercent, setRemainingPercent] = useState(0);

  useEffect(() => {
    const totalTime = getSpentTime(fromDate, toDate).hoursSpent;
    const spentTime = getSpentTime(
      fromDate,
      new Date().toUTCString()
    ).hoursSpent;
    const spentP = Number(Math.round((spentTime / totalTime) * 1000) / 10);
    setSpentPercent(spentP);
    //setRemainingPercent(100 - spentP);
  }, [fromDate, toDate]);

  return (
    <Grid item lg={3} xs={4}>
      <Grid className="box--shadow project_info_card p1 mr-1 h15">
        <Text
          type="normal"
          fonts="normal"
          fontSize={16}
          className="mb0 mt0 fw500"
        >
          Time Spent on Project Till Now
        </Text>
        <Grid className="d-flex h-center v-center">
          <Grid className="halfCircle_chart_box relative">
            <GaugeChart
              id="gauge-chart5"
              nrOfLevels={10}
              arcsLength={[spentPercent, 100 - spentPercent]}
              colors={["#5F67E0", "#FFF390"]}
              percent={spentPercent / 100}
              arcPadding={0.0}
              arcWidth={0.35}
              needleColor={"#5F67E0"}
              needleBaseColor={"#FDD835"}
              cornerRadius={0}
              hideText={true}
            />
            <Text
              type="normal"
              fonts="normal"
              fontSize={16}
              className="mb0 mt0 fw500 w100 absolute"
            >
              <div className="d-flex sb">
                <span>{spentPercent}%</span>
                <span>{Math.round((100 - spentPercent) * 100) / 100}% </span>
              </div>
            </Text>
          </Grid>
        </Grid>
        <Grid className="d-flex sb">
          <Grid className="total_time">
            <Text
              type="normal"
              fonts="normal"
              fontSize={13}
              className="mb0 mt0 fw500 "
            >
              Total Time
            </Text>
            <Text
              type="normal"
              fonts="normal"
              fontSize={14}
              className="mb0 mt0 fw500 "
            >
              {getSpentTime(fromDate, toDate).toString()}
            </Text>
          </Grid>
          <Grid className="remaining_time">
            <Text
              type="normal"
              fonts="normal"
              fontSize={13}
              className="mb0 mt0 fw500 "
            >
              Remaining Time
            </Text>
            <Text
              type="normal"
              fonts="normal"
              fontSize={14}
              className="mb0 mt0 fw500 "
            >
              {getSpentTime(new Date().toUTCString(), toDate).toString()}
            </Text>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default UserTimeSpent;